import { Vector3 } from "three";

export default class CollisionConstants {
    public static COLLISION_DISTANCE = 0.1;
    public static DOWN_FACING_VECTOR = new Vector3(0, -1, 0);
}
